console.log(" Carousel script loaded");

interface Video {
    src: string;
    titleLeft: string;
    titleRight: string;
}

const videos: Video[] = [
    {
        src: "./videos/video1.mp4",
        titleLeft: "Guide for Quiz Tools",
        titleRight: "Guide for 3D Models"
    },
    {
        src: "./videos/video2.mp4",
        titleLeft: "Guide for Histology",
        titleRight: "Guide for Classroom"
    },
    {
        src: "./videos/video3.mp4",
        titleLeft: "Guide for 3D Models",
        titleRight: "Guide for Quiz Tools"
    }
];

let currentIndex: number = 1;

function updateVideos(): void {
    const main = document.getElementById("mainVideo") as HTMLVideoElement | null;
    const left = document.getElementById("leftVideo") as HTMLVideoElement | null;
    const right = document.getElementById("rightVideo") as HTMLVideoElement | null;

    const leftTitle = document.getElementById("leftTitle");
    const rightTitle = document.getElementById("rightTitle");

    if (!main || !left || !right || !leftTitle || !rightTitle) {
        console.error("One or more video or title elements not found.");
        return;
    }

    const prevIndex = (currentIndex - 1 + videos.length) % videos.length;
    const nextIndex = (currentIndex + 1) % videos.length;

    main.src = videos[currentIndex].src;
    left.src = videos[prevIndex].src;
    right.src = videos[nextIndex].src;

    leftTitle.textContent = videos[prevIndex].titleLeft;
    rightTitle.textContent = videos[nextIndex].titleRight;
}

function navigate(direction: number): void {
    currentIndex = (currentIndex + direction + videos.length) % videos.length;
    updateVideos();
}


document.addEventListener("DOMContentLoaded", () => {
    updateVideos();

    const leftNav = document.querySelector(".navItem.left");
    const rightNav = document.querySelector(".navItem.right");

    if (leftNav) {
        leftNav.addEventListener("click", () => navigate(-1));
    }

    if (rightNav) {
        rightNav.addEventListener("click", () => navigate(1));
    }
});
